import { render, staticRenderFns } from "./Parametrizacao.vue?vue&type=template&id=875f4488&scoped=true"
import script from "./Parametrizacao.vue?vue&type=script&lang=js"
export * from "./Parametrizacao.vue?vue&type=script&lang=js"
import style0 from "./Parametrizacao.vue?vue&type=style&index=0&id=875f4488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875f4488",
  null
  
)

export default component.exports